import { type GameConfig, MagicSlot } from '@magic/slot';
import { demoConfig } from './demo';

const gameConfig: GameConfig = {
    cols: 5,
    rows: 3,
    symbols: ['H1', 'H2', 'H3', 'H4', 'H5', 'L1', 'L2', 'L3', 'L4', 'L5', 'W', 'S', 'B'],
    minSpinTime: 0,
    reelStopDelay: 200,
    anticipationSpinTime: 2000,
    minHeight: 1080,
    minWidth: 1080,
    sounds: [],
};

new MagicSlot(gameConfig, demoConfig);
